import {
  EditGLDStartRegistrationTask,
  GLDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGldLibraryFields } from "../../../schema/gld-schema-library";

const sharedTitle = (type: FormType | undefined) => `GLD Start Registratie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GLD Start Registratie formulier. ${getDocsLinkMarkdown(
  "GLD"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  required: ["objectIdAccountableParty", "gmwBroId", "tubeNumber"],
  properties: pickGldLibraryFields([
    "objectIdAccountableParty",
    "gmwBroId",
    "tubeNumber",
    "groundwaterMonitoringNets",
  ]),
};

const getGldStartRegistrationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<GLDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGldLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGldStartRegistrationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGLDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGldLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGldLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGldStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGLDStartRegistrationTask>;
export function getGldStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<GLDStartRegistrationTask>;
export function getGldStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGLDStartRegistrationTask> | SchemaForFormData<GLDStartRegistrationTask>;
export function getGldStartRegistrationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGldStartRegistrationEditSchema(type)
    : getGldStartRegistrationCreateSchema(type);
}
